(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteDetailController', EntiteParenteDetailController);

    EntiteParenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EntiteParente', 'Agence'];

    function EntiteParenteDetailController($scope, $rootScope, $stateParams, entity, EntiteParente, Agence) {
        var vm = this;
        vm.entiteParente = entity;
        vm.load = function (id) {
            EntiteParente.get({id: id}, function(result) {
                vm.entiteParente = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:entiteParenteUpdate', function(event, result) {
            vm.entiteParente = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
